module.exports = __webpack_public_path__ + "img/icon_yisheng_nan.b4855cea.png";